/* global axios */
import ApiClient from './ApiClient';

class InboxChannelsAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  createWithChannels(payload) {
    return axios.post(`${this.url}/create_with_channels`, payload);
  }
}

export default new InboxChannelsAPI();
